import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function AccounttypesReducer(state = initialState.accounttypes, action: any) {
  switch (action.type) {
    case types.SAVE_ACCOUNTTYPES_SUCCESS:
      return action.accounttypes;
    default:
      return state;
  }
}
